require('./validation');

$.fn.hasAttr = function(name) {
    return this.attr(name) !== undefined;
};

$('[name="DATA[FORM]"],[name="form"]').each(function(index, el) {
    $(el).val($(this).closest('section').attr('id'));
});

$('img[alt=""]').each(function(){
    var $img = $(this);
    var filename = $img.attr('src');
    var clean = filename.substring((filename.lastIndexOf('/'))+1, filename.lastIndexOf('.')).replace(/([\-\_\+\.]|(min)$)/g, ' ');
    $img.attr('alt', clean);
});

$('a.scroll').click(function(event) {
    event.preventDefault();
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') || location.hostname == this.hostname) {
        var target = $(this.hash);
        var offset = $(this).hasAttr('data-offset') ? $(this).attr('data-offset') : 0;
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
            $('html,body').animate({
                scrollTop: target.offset().top + parseInt(offset, 10)
            }, 1000);
            return false;
        }
    }
});

// ====== POPUP
$('[data-popup-open]').on('click', function(event) {
    event.preventDefault();
    var $this = $(this),
        sectionid = $this.closest('section').attr('id'),
        popupname = $this.attr('data-popup-open'),
        $popup = $('[data-popup="'+popupname+'"]');

    // disableScroll();
    $popup.find('[name="DATA[FORM]"]').val('Popup - '+sectionid);
    $popup.removeClass('dn').fadeTo(400, 1);
});

$('[data-popup-bg], [data-popup-close], [data-popup-close]').on('click', function(event) {
    event.preventDefault();
    const $this = $(this);
    // enableScroll();
    $this.closest('[data-popup]').fadeTo(400, 0, function() {
        $(this).addClass('dn');
    });
    if ($this.attr('data-popup-close') === 'reset') {
        setTimeout(function() {
            $('[data-popup-content]').show();
            $('[data-popup-success]').hide();
            $('[data-popup-failed]').hide();
        }, 450);
    }
});

$('form').on('submit_success', function() {
    const $blocker = $(this).find('.blocker').add($(this).siblings('.blocker'));
    $blocker.fadeIn(400);
    gtag('event', typeof gEventAction !== 'undefined' ? gEventAction : 'LP-Adwords-Seminar', {
        event_category: typeof gEventCategory !== 'undefined' ? gEventCategory : 'Conversions',
        event_label: typeof gEventLabel !== 'undefined' ? gEventLabel : 'Reservation',
    });
});

$(function() {
    function getTextTime(dateTime) {
        let hours = dateTime.getHours();
        if (hours < 10) {
            hours = '0' + hours;
        }
        let minutes = dateTime.getMinutes();
        if (minutes < 10) {
            minutes = '0' + minutes;
        }

        return `${hours}:${minutes}`;
    }

    if (typeof localizeStartTime !== 'undefined') {
        let $options = $('[name="DATA[DATE]"]').find(`[value*="${originalStartTime}"]`);
        let toReplace = [
            $options,
            $('.date_time'),
            $('#schedule .time'),
        ];

        if (!$options.length) {
            return;
        }

        let newStartTime = getTextTime(localizeStartTime);
        let newEndTime = getTextTime(localizeEndTime);
        $options.val($options.val().replace(originalStartTime, newStartTime));

        for (let $replace of toReplace) {
            $replace.each((key, $val) => {
                $val = $($val);
                $val.html($val.html()
                    .replace(originalStartTime, newStartTime)
                    .replace(originalEndTime, newEndTime))
            });
        }
    }
});
